import * as types from '../../../actions';

const initialState = {
    items: [],
    status:0,
    item:{
        id:'',
        name:'',
        sectorId:''
    },
    activity:'',
    sectors:[],
    count:'',
    errorData:''
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {
        case types.SUBSECTOR_LIST_SUPERADMIN_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.SUBSECTOR_LIST_SUPERADMIN_SUCCESS,
                    count:response.data.length                
                };
            }else{
                return {
                    ...state,
                    status: response.status,   
                    activity:types.SUBSECTOR_LIST_SUPERADMIN_ERROR,                              
                };
            }      
        case types.SECTOR_ALL_SUPERADMIN_LIST_SUCCESS:
            return {
                ...state,
                sectors:response.data,
                activity:types.SECTOR_ALL_SUPERADMIN_LIST_SUCCESS,
            };

        case types.SUBSECTOR_ADD_SUPERADMIN_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.SUBSECTOR_ADD_SUPERADMIN_SUCCESS,
                }    
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.SUBSECTOR_ADD_SUPERADMIN_ERROR,
                    errorData:response.data
                }    
            } 
        
        case types.SUBSECTOR_EDIT_SUPERADMIN_SUCCESS:   
            if(response.status===200){        
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        name: response.data.name,
                        sectorId:response.data.sector
                    },
                    status: response.status,
                    activity:types.SUBSECTOR_EDIT_SUPERADMIN_SUCCESS,               
                }
            }else{
                return {
                    ...state,                    
                    status: response.status,
                    activity:types.SUBSECTOR_EDIT_SUPERADMIN_ERROR,               
                }
            }

        case types.SUBSECTOR_UPDATE_SUPERADMIN_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.SUBSECTOR_UPDATE_SUPERADMIN_SUCCESS,         
                }    
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.SUBSECTOR_UPDATE_SUPERADMIN_ERROR,    
                    errorData:response.data     
                }    
            }       

        case types.SUBSECTOR_DELETE_SUPERADMIN_SUCCESS:
            const id = response.data.id;        
            if(response.status===200){        
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),                
                    status: response.status,
                    activity:types.SUBSECTOR_DELETE_SUPERADMIN_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.SUBSECTOR_DELETE_SUPERADMIN_ERROR,  
                    errorData: response.data, 
                }
            }
     
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name:'',
                    sectorId:''
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
    }
  };